<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header d-none">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Mustering Area</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">This is mustering area menu</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid mt-5">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">E-Mustering List</h4>

              <!-- Switch -->
              <div class="form-check form-switch">
                <button
                  class="btn btn-success"
                  v-b-modal.modal-1
                  @click="isAdd = true"
                >
                  <i class="fe fe-plus-circle"></i>
                  <span class="ms-2">Create new</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-end mb-3">
                <label class="align-self-center mb-0 mr-3">Search</label>
                <b-form-input
                  v-model="searchTerm"
                  class="w-auto"
                  placeholder="Type Here..."
                ></b-form-input>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="list"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  externalQuery: searchTerm,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength,
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'details'">
                    {{ props.row.details.length }} Area
                  </span>
                  <span v-else-if="props.column.field == 'area'">
                    {{ dataArea(props.row) }}
                  </span>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center no-wrap"
                  >
                    <button
                      v-if="props.row.is_sent == false"
                      class="btn btn-sm btn-secondary me-2"
                      @click="send(props.row)"
                    >
                      <span class="fe fe-send"></span>
                    </button>
                    <button
                      v-else
                      class="btn btn-sm btn-info me-2"
                      @click.prevent="
                        $router.push(`/mustering/${props.row.id}/details`)
                      "
                    >
                      <span class="fe fe-alert-circle"></span>
                    </button>
                    <button
                      v-if="props.row.is_sent == false"
                      class="btn btn-sm btn-warning me-2"
                      @click="updateData(props.row)"
                    >
                      <span class="fe fe-edit"></span>
                    </button>
                    <button
                      v-if="props.row.is_sent == false"
                      class="btn btn-sm btn-danger"
                      @click.prevent="remove(props.row.id)"
                    >
                      <span class="fe fe-trash-2"></span>
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="
                          (value) => props.pageChanged({ currentPage: value })
                        "
                      >
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
      <b-modal
        id="modal-1"
        size="lg"
        hide-footer
        title="Form mustering Area"
        centered
      >
        <form @submit.prevent="saveAdd()" v-if="isAdd === true">
          <div class="form-group">
            <div class="row g-3">
              <div class="form-group col">
                <label>Incident</label>
                <input
                  type="text"
                  v-model="bodyAdd.title"
                  class="form-control"
                  placeholder="Title"
                  v-validate="'required'"
                  name="Title"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Title')"
                  >{{ errors.first("Title") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Impacted Area</label>
                <v-select
                  v-model="bodyAdd.area"
                  :options="location"
                  label="location_name"
                  :reduce="(e) => e.id"
                  name="Area"
                  v-validate="'required'"
                  multiple
                />
                <span class="text-sm text-danger" v-show="errors.has('Area')">{{
                  errors.first("Area")
                }}</span>
              </div>
              <div class="form-group col-12">
                <label>Description</label>
                <input
                  type="text"
                  v-model="bodyAdd.description"
                  class="form-control"
                  placeholder="Description"
                  v-validate="'required'"
                  name="Description"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Description')"
                  >{{ errors.first("Description") }}</span
                >
              </div>
            </div>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false"
            >
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
          </div>
        </form>

        <form @submit.prevent="saveUpdate()" v-else>
          <div class="form-group">
            <div class="row g-3">
              <div class="form-group col">
                <label>Incident</label>
                <input
                  type="text"
                  v-model="bodyUpdate.title"
                  class="form-control"
                  placeholder="Title"
                  v-validate="'required'"
                  name="Title"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Title')"
                  >{{ errors.first("Title") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Impacted Area</label>
                <v-select
                  v-model="bodyUpdate.area"
                  :options="location"
                  label="location_name"
                  :reduce="(e) => e.id"
                  multiple
                />
              </div>
              <div class="form-group col-12">
                <label>Description</label>
                <input
                  type="text"
                  v-model="bodyUpdate.description"
                  class="form-control"
                  placeholder="Description"
                  v-validate="'required'"
                  name="Description"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Description')"
                  >{{ errors.first("Description") }}</span
                >
              </div>
            </div>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false"
            >
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
          </div>
        </form>
      </b-modal>
      <b-modal id="modal-2" size="lg" hide-footer title="mustering Area">
        <div class="form-group">
          <div class="row g-3">
            <div class="form-group col-12">
              <label>Title</label>
              <input
                type="text"
                v-model="bodyUpdate.title"
                class="form-control"
                placeholder="Title"
                v-validate="'required'"
                name="Title"
                disabled
              />
            </div>
            <div class="form-group col-12">
              <label>Area</label>
              <v-select
                v-model="bodyUpdate.area"
                label="location_name"
                name="Area"
                v-validate="'required'"
                multiple
                disabled
              />
            </div>
            <div class="form-group col-12">
              <label>Description</label>
              <input
                type="text"
                v-model="bodyUpdate.description"
                class="form-control"
                placeholder="Description"
                v-validate="'required'"
                name="Description"
                disabled
              />
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "restrictedAreaComponent",
  computed: {
    columns() {
      return this.$store.getters["mustering/columns"];
    },
    list() {
      return this.$store.getters["mustering/list"];
    },
    location() {
      return this.$store.getters["location/list"]
        ? this.$store.getters["location/list"]
        : [];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      isAdd: true,
      isLoading: false,
      bodyAdd: {
        title: "",
        description: "",
        area: [],
      },
      bodyUpdate: {
        id: "",
        title: "",
        description: "",
        area: [],
      },
    };
  },
  mounted() {
    this.getList();
    this.getLocation();
    console.log("location option", this.location);
  },
  methods: {
    getList() {
      this.$store.dispatch("mustering/GET_LIST");
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("YYYY/MM/DD HH:mm:ss");
      }
      return date;
    },
    format(value, event) {
      return moment(value).format("YYYY-MM-DDTHH:mm:ss");
    },
    dataArea(props) {
      const data_area = props.area;
      let datas = data_area.map((e) => {
        return e.location_name;
      });
      return datas.join(", ");
    },
    reset() {
      this.bodyAdd.title = "";
      this.bodyAdd.description = "";
      this.bodyAdd.area = "";
    },
    updateData(props) {
      const data_area = props.area;
      let datas = data_area.map((item) => {
        return item.location_id;
      });
      this.$bvModal.show("modal-1");
      this.isAdd = false;
      this.reset();
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.title = props.title;
      this.bodyUpdate.description = props.description;
      this.bodyUpdate.area = datas;
      // this.bodyUpdate.area = props.area;
      console.log(datas);
      console.log(props.area);
    },
    detailData(props) {
      this.$bvModal.show("modal-2");
      this.isAdd = false;
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.title = props.title;
      this.bodyUpdate.description = props.description;

      const data_area = props.area;
      var datas = data_area.map((item) => {
        return { location_name: item.location_name };
      });
      this.bodyUpdate.area = datas;
    },
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        const data = {
          title: this.bodyAdd.title,
          area: this.bodyAdd.area,
          description: this.bodyAdd.description,
        };
        // return console.log(data);
        try {
          this.isLoading = true;
          this.$store.dispatch("mustering/CREATE", data).then((resp) => {
            this.$swal({
              title: "Saved",
              text: "Your input has been saved",
              icon: "success",
              confirmButtonText: "OK",
            }).then((resp) => {
              this.isLoading = false;
              this.bodyAdd.title,
                this.bodyAdd.area,
                this.bodyAdd.description,
                this.getList();
              this.reset();
              this.$bvModal.hide("modal-1");
            });
          });
        } catch (resp) {
          this.$swal("Error", "Error while add data", "error");
        }
      });
    },
    saveUpdate() {
      const data = {
        id: this.bodyUpdate.id,
        title: this.bodyUpdate.title,
        area: this.bodyUpdate.area,
        description: this.bodyUpdate.description,
      };
      // return console.log(data);
      this.isLoading = true;
      this.$store
        .dispatch("mustering/UPDATE", data)
        .then((resp) => {
          this.$swal({
            title: "Saved",
            text: "Your input has been saved",
            icon: "success",
            confirmButtonText: "OK",
          }).then((resp) => {
            this.isLoading = false;
            this.getList();
            this.$bvModal.hide("modal-1");
          });
        })
        .catch((resp) => {
          this.$swal("Error", "Error while edit data", "error");
        });
    },
    remove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#AF0404",
        cancelButtonColor: "#414141",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("mustering/DELETE", { id: id }).then(() => {
            this.$swal(
              "Success",
              "Area restriction has been deleted",
              "success"
            );
            this.getList();
          });
        }
      });
    },
    send(row) {
      console.log("row", row);
      this.$swal({
        title: "Send this information to employee in the area?",
        text: "After send this information, you can't edit or delete this data",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#AF0404",
        cancelButtonColor: "#414141",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("mustering/SEND", row.id).then(() => {
            this.$swal("Success", "Alert has been sent", "success");
            this.getList();
          });
        }
      });
    },
    async getLocation() {
      this.$store.dispatch("location/GET_LIST");
    },
  },
};
</script>
